// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1w-e";
export var animationRelative = "_1w-d";
export var backdropBlur = "_1w-0";
export var detailLabelCell = "_1w-q";
export var detailTable = "_1w-p";
export var detailValueCell = "_1w-r";
export var documentTypeIcon = "_1w-y";
export var documentTypeOption = "_1w-x";
export var dropdownMatchDatePicker = "_1w-3";
export var evidenceCardContent = "_1w-w";
export var gorgiasTicketCard = "_1w-s";
export var iconTertiary = "_1w-z";
export var integrationCard = "_1w-1";
export var integrationLogoBox = "_1w-2";
export var mainColumnSticky = "_1w-v";
export var maxWidthContainer = "_1w-t";
export var modalContentBody = "_1w-a";
export var modalHeaderImage = "_1w-5";
export var modalImageLabel = "_1w-7";
export var modalImageOverlay = "_1w-6";
export var modalImageSubtitle = "_1w-9";
export var modalImageTitle = "_1w-8";
export var modalImageWrapper = "_1w-4";
export var modalStickyFooter = "_1w-b";
export var sidebarColumn = "_1w-u";
export var timelineLine = "_1w-m";
export var timelineLineBlack = "_1w-o _1w-m";
export var timelineLineGray = "_1w-n _1w-m";
export var timelineLineHeight = "_1w-l";
export var tlDotActivate = "_1w-i";
export var tlDotActivateAnim = "_1w-h";
export var tlDotHide = "_1w-g";
export var tlDotHideAnim = "_1w-f";
export var tlLineActivate = "_1w-k";
export var tlLineActivateAnim = "_1w-j";
export var uploadedFileRow = "_1w-c";